"use client";

import { useCallback } from "react";

import { useAppContext } from "@/context/AppContext";
import type { HintWindowPreference } from "@/types";

export function useHintWindowPreference(hint: HintWindowPreference) {
  const { updateUserPreferences, userPreferences } = useAppContext();
  const isOpen = userPreferences.hintWindows[hint];

  const setIsOpen = useCallback(
    (nextIsOpen: boolean) => {
      void updateUserPreferences({
        hintWindows: {
          ...userPreferences.hintWindows,
          [hint]: nextIsOpen,
        },
      });
    },
    [hint, updateUserPreferences, userPreferences.hintWindows],
  );

  const toggle = useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen, setIsOpen]);

  return { isOpen, setIsOpen, toggle };
}
